import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { useUIStateContext } from "../contexts/UIStateContext";
import { useUserContext } from "../contexts/UserContext";
import { RowDataReducerState } from "../types";
import { determineSetupMode } from "../pages/LandingPage/helpers";

export function useLandingPageState(rowDataReducerState: RowDataReducerState) {
  const {
    isRecordOpen,
    isSideSheetOpen,
    landingPageToast,
    setLandingPageToast,
  } = useUIStateContext();

  const { isFetchingUserData, selected } = useUserContext();

  const { setup } = selected;
  const isSetupSelected = setup.value !== "";

  const { rowDataList, columnDefs } = rowDataReducerState;

  const isTableDataFetching =
    useIsFetching({ queryKey: ["refetchTableData"] }) > 0;
  const isRefetchingRowDataList =
    useIsMutating({ mutationKey: ["refetchTableData"] }) > 0;
  const isRowDataListFetching =
    useIsFetching({ queryKey: ["refetchRowDataList"] }) > 0;

  const isLoading =
    isTableDataFetching || isRowDataListFetching || isRefetchingRowDataList;

  const shouldShowEmptyState =
    isSetupSelected &&
    rowDataList.length === 0 &&
    columnDefs.length === 0 &&
    !isLoading;

  const showNavTabs = isSetupSelected && !isRecordOpen;
  const showNavHeader = isSetupSelected && !isRecordOpen && !isLoading;
  const showLandingPageToast = landingPageToast.message.length > 0;

  const setupMode = determineSetupMode(rowDataReducerState.schema);
  const isSideSheetSetup =
    setupMode === "NORMAL_SIDE_SHEET_SETUP" ||
    setupMode === "INVENTORY_BUILDINGS_SETUP";
  const showSideSheet = isSideSheetSetup;

  return {
    isRecordOpen,
    isSideSheetOpen,
    landingPageToast,
    setLandingPageToast,
    isFetchingUserData,
    isSetupSelected,
    isLoading,
    shouldShowEmptyState,
    showNavTabs,
    showNavHeader,
    showLandingPageToast,
    showSideSheet,
  };
}
